import {
  SET_REQUESTED_PROMOTION,
  UPDATED_REQUESTED_PROMOTION,
  SET_MAINTAIN_PROMOTION,
  UPDATED_MAINTAIN_PROMOTION,
  SET_VALIDATE_PROMOTION,
  UPDATED_VALIDATE_PROMOTION,
  SET_APPROVED_PROMOTION,
  UPDATED_APPROVED_PROMOTION,
} from "../../types";

const initialState = {
  getRequestPromotion: {},
  updateRequestPromotion: {},
  getMaintainPromotion: {},
  updateMaintainPromotion: {},
  getValidatePromotion: {},
  updateValidatePromotion: {},
  getApprovedPromotion: {},
  updateApprovedPromotion: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_REQUESTED_PROMOTION:
      return {
        ...state,
        getRequestPromotion: action.payload,
      };
    case UPDATED_REQUESTED_PROMOTION:
      return {
        ...state,
        updateRequestPromotion: action.payload,
      };
    case SET_MAINTAIN_PROMOTION:
      return {
        ...state,
        getMaintainPromotion: action.payload,
      };
    case UPDATED_MAINTAIN_PROMOTION:
      return {
        ...state,
        updateMaintainPromotion: action.payload,
      };
    case SET_VALIDATE_PROMOTION:
      return {
        ...state,
        getValidatePromotion: action.payload,
      };
    case UPDATED_VALIDATE_PROMOTION:
      return {
        ...state,
        updateValidatePromotion: action.payload,
      };
    case SET_APPROVED_PROMOTION:
      return {
        ...state,
        getApprovedPromotion: action.payload,
      };
    case UPDATED_APPROVED_PROMOTION:
      return {
        ...state,
        updateApprovedPromotion: action.payload,
      };

    default:
      return state;
  }
}
